import { Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from '@angular/material/core';
import { MomentDatetimeAdapter } from '@ng-matero/extensions-moment-adapter';
import { DatetimeAdapter, MTX_DATETIME_FORMATS } from '@ng-matero/extensions/core';
import { MtxCalendarView, MtxDatetimepickerMode, MtxDatetimepickerType } from '@ng-matero/extensions/datetimepicker';

import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: "date-input-ctrl",
  templateUrl: "./date-input.component.html",
  styleUrls: ["./date-input.component.scss"],
  providers: [   {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
  },
  {
    provide: DatetimeAdapter,
    useClass: MomentDatetimeAdapter,
  },
  {
    provide: MTX_DATETIME_FORMATS,
    useValue: {
      parse: {
        dateInput: 'DD-MM-YYYY',
        monthInput: 'MMMM',
        timeInput: 'HH:mm',
        datetimeInput: 'DD-MM-YYYY HH:mm',
      },
      display: {
        dateInput: 'DD-MM-YYYY',
        monthInput: 'MMMM',
        timeInput: 'HH:mm',
        datetimeInput: 'DD-MM-YYYY HH:mm',
        monthYearLabel: 'YYYY MMMM',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
        popupHeaderDateLabel: 'MMM DD, ddd',
      },
    },
  },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DateInputComponent,
      multi: true,
    },
  ],
})
export class DateInputComponent implements ControlValueAccessor {
  constructor(
    @Optional() private controlContainer: ControlContainer
  ) {}

  //settings for external datePicker
  type: MtxDatetimepickerType = "date";
  mode: MtxDatetimepickerMode = "portrait";
  startView: MtxCalendarView = "month";
  multiYearSelector = false;
  touchUi = false;
  twelvehour = false;
  timeInterval = 1;

  value?: Date;
  disabled = false;
  onTouchedFn: () => void = () => {};
  onChangedFn: (date: Date) => void = () => {};

  @Input() caption = '';
  @Input() formControlName = '';
  @Input() settings: ControlSettings = {};

  @Output() valueChangeEvent = new EventEmitter<any>();
  
  defaultSettings: ControlSettings = { format: "yyyy-MM-dd", fxFill: false, readonly : false };

  ngOnInit(): void {
    Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  registerOnChange(fn: any): void {
    this.onChangedFn = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(date: Date) {
    this.value = date;
    this.onChangedFn(date);
    this.valueChangeEvent.emit(date);
  }

  get showValidationError(): boolean {
    return !!this.control && this.control.invalid;
  }

  private get control() {
    return this.controlContainer?.control?.get(this.formControlName);
  }
}
